import { ReactNode } from 'react';
import { BlindStateDirectionInternal, GateEventTypeInternal } from '../../../../../data-access/gql-types/graphql';
import {
  BlindStateTask,
  DimStateTask,
  GatePartialControlModeStateTask,
  GateDailyModeStateTask,
  GateStateTask,
  MicroventilationStateTask,
  OnOffStateTask,
  RGBWStateTask,
} from '../../../../../types/actions';
import { ChannelType } from '../../../types';

export enum SceneTaskType {
  Unknown = 'Unknown',
  ChannelState = 'ChannelState',
}

export type ActionTaskOption = {
  title: string;
  icon: ReactNode;
  type: SceneTaskType;
};

export enum TaskVariant {
  Undefined = 'undefined',
  OnOff = 'onOff',
  Dim = 'dim',
  SetRGBW = 'setRGBW',
  SetBlind = 'setBlind',
  SetGate = 'setGate',
  SetVentilation = 'setVentilation',
  SetGateDailyMode = 'setGateDailyMode',
  SetGatePartialControlMode = 'setGatePartialControlMode',
}

export type ActionTaskVariantOption = {
  title: string;
  icon: ReactNode;
  variant: TaskVariant;
};

export type DeviceTaskParams = {
  channel: ChannelType;
  state: TaskState;
  variant: TaskVariant;
};

export type TaskState =
  | OnOffStateTask
  | DimStateTask
  | MicroventilationStateTask
  | RGBWStateTask
  | BlindStateTask<BlindStateDirectionInternal>
  | GateStateTask<GateActionInternal>
  | GateDailyModeStateTask<GateEventTypeInternal>
  | GatePartialControlModeStateTask<GateEventTypeInternal>;

export type TaskParams = DeviceTaskParams;

export type Task = {
  id: string;
  taskType: SceneTaskType;
  taskParams: TaskParams;
};

export enum GateActionInternal {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Stopped = 'STOPPED',
  Tilt = 'TILT',
  Unknown = 'UNKNOWN',
}
